import { AbsoluteFill, Img } from "remotion";
import { resolveSrc } from "./mediaSrc.ts";
import { LEGACY_LOGO_LAYOUT } from "./types.ts";

interface LogoMarkProps {
  /** Path under public/ — defaults to legacy Quotologies asset for back-compat. */
  src?: string;
  /** Width as % of canvas width. Default 36 (Quotologies). */
  widthPct?: number;
  /** Distance from bottom in px. Default 620 (Quotologies). */
  bottomPx?: number;
  /** 0–1. Default 1. */
  opacity?: number;
  /** Horizontal position of the logo's CENTRE as % of canvas width. Default 50
   *  (dead-centre). translateX(-50%) keeps xPct the logo's own centre, so
   *  xPct=50 renders `left:50%` — byte-identical to the founding logo. */
  xPct?: number;
}

export const LogoMark = ({
  src,
  widthPct = LEGACY_LOGO_LAYOUT.widthPct,
  bottomPx = LEGACY_LOGO_LAYOUT.bottomPx,
  opacity = LEGACY_LOGO_LAYOUT.opacity,
  xPct = LEGACY_LOGO_LAYOUT.xPct,
}: LogoMarkProps): React.JSX.Element => (
  <AbsoluteFill style={{ pointerEvents: "none" }}>
    <Img
      src={resolveSrc(src ?? "assets/Logo-Quotologies.png")}
      // Hit-test seam for the Studio canvas overlay; inert in renders.
      data-studio-el="logo"
      style={{
        position: "absolute",
        bottom: bottomPx,
        left: `${xPct}%`,
        transform: "translateX(-50%)",
        width: `${widthPct}%`,
        height: "auto",
        opacity,
      }}
    />
  </AbsoluteFill>
);
